<form class="w-100 h-100 form" [formGroup]="contactInfoForm">
  <h4 class="text-center mb-5">{{ data.reniecName }} - {{data.reference}}</h4>
  <button class="btn-close" (click)="onNoClick()"></button>
  <div class="row mx-0 mt-3 pt-0 pb-0 w-100">
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha</mat-label>
          <input matInput placeholder="Fecha de consulta" formControlName="date" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Hora</mat-label>
          <input matInput placeholder="Fecha de consulta" formControlName="hour" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo</mat-label>
          <input matInput placeholder="Tipo de consulta" formControlName="type" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Canal de Contacto</mat-label>
          <input matInput placeholder="Canal de consulta" formControlName="channel" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label> Número telefónico </mat-label>
          <input matInput placeholder=" Número telefónico " formControlName="phone" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Correo</mat-label>
          <input matInput placeholder="Correo" formControlName="email" readonly>
        </mat-form-field>
      </div>
    </div>
    <!--    <div class="col-3">-->
    <!--      <div>-->
    <!--        <mat-form-field appearance="outline" class="w-100">-->
    <!--          <mat-label>Nombre</mat-label>-->
    <!--          <input matInput placeholder="Nombre" formControlName="reniecName" readonly>-->
    <!--        </mat-form-field>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label> {{this.contactInfo.document.length === 8 ? 'DNI': 'CE'}} </mat-label>
          <input matInput placeholder="Estado actual" formControlName="document" readonly>
        </mat-form-field>
      </div>
    </div>
    <!-- <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Producto de interés </mat-label>
          <input matInput placeholder="Producto de interes" formControlName="reference" readonly>
        </mat-form-field>
      </div>
    </div> -->
  </div>
  <div class="bottom-button">
    <button class="vs-btn-blue" (click)="onNoClick()">
      Cerrar
    </button>
  </div>
</form>